import { styled, MenuItem, MenuItemProps } from '@mui/material';

interface MenuItemStyledProps extends MenuItemProps {
  red?: boolean;
  green?: boolean;
}

export const MenuItemStyled = styled(MenuItem)<MenuItemStyledProps>(
  ({ theme, red, green }) => {
    let color;
    if (red) {
      color = theme.palette.error.main;
    } else if (green) {
      color = theme.palette.success.main;
    } else {
      color = 'inherit';
    }

    return {
      color,
      '&:not(:last-child)': {
        borderBottom: '1px solid',
        borderColor: theme.palette.dark.dark_5,
      },
    };
  },
);
